/**
 * Utility module: getMatchStats/getCards.js.
 */

import { getAwayTeam, getHomeTeam } from './getTeams';

/** @typedef {import('./types').Match} Match */
/** @typedef {import('./types').Card} Card */

/** Card types Opta uses for a player being sent off. */
const DISMISSAL_TYPES = new Set(['RC', 'Y2C']);

/**
 * All sending-off cards (straight red and second-yellow) from a match.
 *
 * @param {Match} match
 * @returns {Card[]}
 */
const getRedCards = (match) =>
  match?.liveData?.card?.filter((c) => DISMISSAL_TYPES.has(c.type)) ?? [];

/**
 * Internal: filter red cards by team id.
 *
 * @param {Match} match
 * @param {'home' | 'away'} side
 * @returns {Card[]}
 */
const getRedCardsForSide = (match, side) => {
  const team = side === 'home' ? getHomeTeam(match) : getAwayTeam(match);
  if (!team) return [];
  return getRedCards(match).filter((c) => c.contestantId === team.id);
};

/**
 * Red cards (incl. second yellows) received by the home team.
 *
 * @param {Match} match
 * @returns {Card[]}
 */
export const getHomeRedCards = (match) => getRedCardsForSide(match, 'home');

/**
 * Red cards (incl. second yellows) received by the away team.
 *
 * @param {Match} match
 * @returns {Card[]}
 */
export const getAwayRedCards = (match) => getRedCardsForSide(match, 'away');
